import { useTLang } from 'intl/intl';

export function useSearchResultLang(props: Props) {
  const { notResults } = props;

  const title = useTLang({
    id: notResults
      ? 'menuPage.searchResults.title.notResults'
      : 'menuPage.searchResults.title.results',
  });

  return {
    title: title,
  };
}

interface Props {
  notResults: boolean;
}
